// StorageCleaner.js
'use strict';
import { connect } from 'react-redux';

import StorageCleaner from '../component/StorageCleaner.jsx';

export default connect(null, null)(StorageCleaner);
